module.exports = __webpack_public_path__ + "img/img_82837_0_25.36bf47c9.png";